var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const requestHasBody_1 = __importDefault(require("./requestHasBody"));
const serializeDates_1 = __importDefault(require("../valueTransformers/serializeDates"));
function generateBody(requestOptions) {
    const { action, data } = requestOptions;
    if (!(0, requestHasBody_1.default)(action)) {
        return null;
    }
    let body = null;
    if (action === 'Upload') {
        if (data instanceof FormData) {
            body = data;
        }
        else {
            body = new FormData();
            for (const file of data) {
                body.append('files[]', file, file.name);
            }
        }
    }
    else {
        const keys = data ? Object.keys(data) : [];
        const { includeTime } = requestOptions.requestOptions || {};
        const dataToPass = (0, serializeDates_1.default)(data, { includeTime });
        body = JSON.stringify(keys.length === 1 ? dataToPass[keys[0]] : dataToPass);
    }
    return body;
}
exports.default = generateBody;
//# sourceMappingURL=generateBody.js.map